import React, { useState } from 'react'
import { IconArrowsMaximize, IconPictureInPictureOn } from '@tabler/icons-react'
import classNames from 'classnames'
import { isEmpty } from 'lodash'

import { Button } from '@/components/buttons/Button'
import { SegmentedControl } from '@/components/buttons/SegmentedControl'

import { useVideoPlayer } from './VideoPlayerContext'
import { VideoPlayerToggleButton } from './components/VideoPlayerToggleButton'

import './VideoPlayer.scss'

const VideoPlayer = ({
  sources = [],
  onPlaying,
  onPause,
  onSeeked,
  progress,
  playbackRate,
  isPlaying,
}) => {
  const {
    videoRef,
    jumpVideoTo,
    playVideo,
    changeVideoPlaybackRate,
    toggleFullScreen,
    togglePip,
    isVideoMaximized,
    toggleVideoMaximized,
  } = useVideoPlayer()
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0)

  const changeVideoSource = (index) => {
    setCurrentVideoIndex(index)

    if (videoRef.current) {
      videoRef.current.load()
      videoRef.current.onloadeddata = () => {
        jumpVideoTo(progress)
        changeVideoPlaybackRate(playbackRate)

        // Keep playing video if it was already playing
        if (isPlaying) {
          playVideo()
        }
      }
    }
  }

  const handleMaximizeVideo = () => {
    if (!isVideoMaximized) {
      toggleVideoMaximized()
    }
  }

  if (isEmpty(sources)) {
    return null
  }

  return (
    <div className={classNames('video-player', { minimized: !isVideoMaximized })}>
      {isVideoMaximized && (
        <div
          className={classNames('video-player-header', {
            'with-multiple-sources': sources.length > 1,
          })}
        >
          {sources.length > 1 && (
            <SegmentedControl
              items={sources.map((source, index) => ({
                label: `${index + 1}`,
                active: currentVideoIndex === index,
                accessor: source,
                onClick: () => changeVideoSource(index),
                dataTestId: `video-player-tab-${index}`,
              }))}
            />
          )}
          <div className="flex-align-center small-gap">
            <Button small onClick={togglePip}>
              <IconPictureInPictureOn />
              Picture-in-Picture
            </Button>
            <Button small onClick={toggleFullScreen}>
              <IconArrowsMaximize /> Fullscreen
            </Button>
            <VideoPlayerToggleButton toggleVideoMaximized={toggleVideoMaximized} />
          </div>
        </div>
      )}
      <div className="video-player-wrapper">
        <div className="video-player-overlay" onClick={handleMaximizeVideo}>
          <div className="video-expand-button">
            <IconArrowsMaximize />
          </div>
        </div>
        <video ref={videoRef} onSeeked={onSeeked} onPlaying={onPlaying} onPause={onPause}>
          <source src={sources[currentVideoIndex]} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  )
}

export default VideoPlayer
